export default class NetworkService {
  /* @ngInject */
  constructor(Restangular, $q, $log, NavigationService) {
    this.$q = $q;
    this.Restangular = Restangular.withConfig((RestangularConfigurer) => {
      RestangularConfigurer.addResponseInterceptor(data => data.data);
    });
    // The microservice does not handle array as a response in the data object
    // So it has to have a seperate property called experts.
    this.RestangularList = Restangular.withConfig((RestangularConfigurer) => {
      RestangularConfigurer.addResponseInterceptor(data => data.data.experts);
    });
    this.$log = $log;
    this.NavigationService = NavigationService;
  }

  handleNetworkRequest(networkPromise, errorState) {
    this.loading = true;
    return networkPromise
      .then((result) => {
        this.loading = false;

        return result;
      }, (error) => {
        this.loading = false;
        this.$log.error(error);
        this.NavigationService.navigateToErrorScreen(errorState);
      });
  }

  getLoadingState() {
    return this.loading || false;
  }

  getPostCode(postCode) {
    return this
      .handleNetworkRequest(this.Restangular.all('experts/postcode').get(postCode));
  }

  getExperts(data) {
    return this
      .handleNetworkRequest(this.RestangularList.all('experts').getList(data));
  }

  getExpert(id) {
    return this
      .handleNetworkRequest(this.Restangular.one('experts', id).get());
  }

  notifyExpert(id, payload) {
    return this
      .handleNetworkRequest(this.Restangular
         .one('experts', id).all('notification').post(payload), 'root.contact-error');
  }

}




// WEBPACK FOOTER //
// ./src/services/network.service.js